import React from "react";
import loader from "../../assets/img/loader.png";

// Overlay de carga. Es puramente presentacional: quién lo muestra y quién lo
// oculta lo decide App.js a partir de los onLoading/onDoneLoading que llaman
// las páginas. La visibilidad la resuelve el CSS (div.page-loading div.loading).
export default function PreLoader() {
  return (
    <div className="loading containter-fluid">
      <div className="row justify-content-center align-items-center" style={{ height: "100%" }}>
        <div className="col-6 text-center">
          <div className="scale-up-center">
            <img src={loader} height="150px" alt="Cargando..." />
          </div>
        </div>
      </div>
    </div>
  );
}
